<template>
  <img :src="imageURI" class="img-fluid" alt="..." />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ImageComponent",
  components: {},

  props: {
    imageURI: {
      required: true,
      type: String,
    },
  },
});
</script>

<style scoped>
img {
  width: 90%;
  max-width: 120px !important;
  padding-bottom: 30px;
}
</style>
